export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: 'ri-file-list-3-line',
      title: 'Submit Your Request',
      description: 'Tell us what service you need and provide project details in our simple form.'
    },
    {
      number: '2',
      icon: 'ri-user-search-line',
      title: 'Get Matched',
      description: 'We connect you with up to 5 qualified local professionals who can help.'
    },
    {
      number: '3',
      icon: 'ri-chat-quote-line',
      title: 'Compare Quotes',
      description: 'Review proposals, check ratings, and compare pricing from multiple providers.'
    },
    {
      number: '4',
      icon: 'ri-checkbox-circle-line',
      title: 'Hire with Confidence',
      description: 'Choose the best pro for your project and get the job done right.'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Getting quotes from local professionals is easy and completely free
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow h-full">
                <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mb-4 relative">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-emerald-500"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}